import { notificationUtils, mainAPI } from 'root/angular-injector-provider.js';
import listUsersService from 'vRoot/account-profile/modules/manage-users/services/account-manage-users-list.service';

export function handle(promise, saving, handler) {
  const fn = saving? notificationUtils().onSave: notificationUtils().onLoad
  return fn(() => promise, handler)
}

export function loadHotel(id) {
  return handle(mainAPI().hotel.get(id));
}

export function loadContacts(id){
    return handle(mainAPI().chainPortal.getContacts(id))
      .then(r => listUsersService.makeUsers(r.data));
}

export function updateBasicInfo(id, request) {
  return handle(mainAPI().updateEntityDetails(request.type, id, request), true);
}

export function rebrandHotel(id, request) {
  return handle(mainAPI().chainPortal.rebrandHotel(id, request), true);
}

export function updateAmenities(id, amenities) {
  return handle(mainAPI().chainPortal.updateAmenities(id, amenities), true);
}

export function updateAnswers(id, answers) {
  return handle(mainAPI().chainPortal.updateAnswers(id, answers), true);
}

export function getAnswers(id) {
  return mainAPI().chainPortal.getAnswers(id);
}

export function updateGdsCodes(id, codes) {
  return mainAPI().chainPortal.updateGdsCodes(id, codes);
}


export function getRfpActivity(id) {
  return handle(mainAPI().chainPortal.fetchRfpActivity(id));
}

export function listBrands() {
  return handle(mainAPI().chainPortal.listBrands())
}

export function getOrCreateAccount(entityId) {
  return handle(mainAPI().chainPortal.getAccount(entityId))
}

export function createUser(accountId) {
  return listUsersService.createAgent(accountId, true);
}

export function addRequestedHotel(image, hotel) {
  return saveHotel(mainAPI().chainPortal.addRequestedHotel, image, hotel);
}

export function updateRequestedHotel(image, hotel) {
  return saveHotel(mainAPI().chainPortal.updateRequestedHotel, image, hotel);
}

function saveHotel(fn, image, hotel){
  const formData = new FormData();
  formData.append('image', image);
  formData.append('hotel', new Blob([JSON.stringify(hotel)], { type: 'application/json' }));

  return handle(fn(formData), true, { customErrorHandlers: { '400' (e) {
        notificationUtils().showErrorDialog({dialogData: {message: e.data.message, heading: 'Sabre Code'}})
      } } });
}

export function deleteRequestedHotel(ids) {
  return handle(mainAPI().chainPortal.deleteRequestedHotel(ids), true)
}

export function removeFromPortfolio(ids) {
  return handle(mainAPI().hotel.remove(ids), true)
}

export { listUsersService };
